import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed } from 'vue';
// cannot initialize defaults anymore. "Props Default Values (Experimental)"
//   doesn't work.
// Defaults used in the code:
//   iconStyle: 'regular'
//   spin: 'false'
export default /*@__PURE__*/ _defineComponent({
    __name: 'Icon',
    props: {
        name: {},
        iconStyle: {},
        spin: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const classes = computed(() => {
            const cs = [
                'icon',
                styleClass(),
                iconClass()
            ];
            if (props.spin) {
                cs.push('fa-spin');
            }
            return cs;
        });
        function styleClass() {
            const style = props.iconStyle || 'regular';
            return `fa-${style}`;
        }
        function iconClass() {
            return props.name.indexOf('fa-') === 0
                ? props.name
                : 'fa-' + resolveAlias(props.name);
        }
        function resolveAlias(name) {
            switch (name) {
                // alerts
                case 'info':
                    return 'info-circle';
                case 'success':
                    return 'check-circle';
                case 'warning':
                    return 'exclamation-triangle';
                case 'error':
                    return 'times-circle';
                // common
                case 'view':
                    return 'eye';
                case 'delete':
                    return 'trash-alt';
                case 'create':
                case 'add':
                    return 'plus';
                case 'edit':
                    return 'pencil';
                case 'logs':
                    return 'clipboard-list';
                case 'config':
                    return 'gears';
                case 'close':
                    return 'times';
                case 'cancel':
                    return 'ban';
                case 'back':
                    return 'arrow-left';
                case 'login':
                    return 'key';
                case 'true':
                    return 'check-square';
                case 'false':
                    return 'square';
                case 'collapse':
                    return 'compress';
                case 'monitor':
                    return 'monitor-heart-rate';
                case 'help':
                    return 'question-circle';
                case 'import':
                    return 'upload';
                case 'reporting':
                    return 'wave-pulse';
                // operations
                case 'event':
                    return 'podcast';
                case 'task':
                    return 'tasks';
                case 'action':
                    return 'function';
                // shop
                case 'catalog':
                    // return 'cabinet-filing';
                    // return 'book-open';
                    return 'book';
                // return 'books';
                case 'orders':
                case 'cart':
                    return 'shopping-cart';
                case 'delivery':
                case 'deliveries':
                    // return 'truck-loading';
                    return 'truck';
                case 'watchlist':
                case 'watch-list':
                    return 'clipboard-list';
            }
            return name;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("span", {
                class: _normalizeClass(classes.value)
            }, null, 2));
        };
    }
});
